import React from "react";
import { Grid2 as Grid, Grid2Props } from "@mui/material";
import { singleGridItem } from "../../defaultStyles";

interface AccordionSubFormContainerProps extends Grid2Props {
  children?: React.ReactNode;
}

const AccordionSubFormContainer: React.FC<AccordionSubFormContainerProps> = ({
  children,
  ...grid
}) => {
  return (
    <Grid {...singleGridItem} {...grid}>
      {children}
    </Grid>
  );
};

export default AccordionSubFormContainer;
